// Automatically generated in 'npm version' by scripts/genversion.js

'use strict'
const version = '5.2.6';
export default version;
